<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
@import "~@/assets/style/common.css";

.wrap {
  width: 1200px;
  margin: 0 auto;
}
#container,
#service:target,
#cases:target,
#honor:target {
  padding-top: 90px;
}
</style>